import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.aufgabe-fehlerbild-hinzufuegen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenAufgabeFehlerbildHinzufuegenEffects {

    AufgabeFehlerbildHinzufuegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_AUFGABE_FEHLERBILD_HINZUFUEGEN),
        mergeMap((x: ac.PostAufgabeFehlerbildHinzufuegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postAufgabeFehlerbildHinzufuegen(x.aufgabeBildRequest).pipe(
                map((result: any) => {
                    return new ac.PostAufgabeFehlerbildHinzufuegenErfolgreichAction(result, x.aufgabeBildRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostAufgabeFehlerbildHinzufuegenFehlerAction(error, x.aufgabeBildRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AufgabenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AufgabenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AufgabenCommandService);
        }
        return this.service;
    }
}
